import { render, staticRenderFns } from "./ValidRatificacionesDigital.vue?vue&type=template&id=9a9a9a7e"
import script from "./ValidRatificacionesDigital.vue?vue&type=script&lang=js"
export * from "./ValidRatificacionesDigital.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a9a9a7e')) {
      api.createRecord('9a9a9a7e', component.options)
    } else {
      api.reload('9a9a9a7e', component.options)
    }
    module.hot.accept("./ValidRatificacionesDigital.vue?vue&type=template&id=9a9a9a7e", function () {
      api.rerender('9a9a9a7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff/tasks/validaciones/ValidRatificacionesDigital.vue"
export default component.exports